module.exports = __webpack_public_path__ + "img/86.20d2027c.svg";